import asyncActionTypes from '../actions/types.js';

const initialState = {
  ancillaries: [],
};

const infoForPurchaseMetric = (state = initialState, action) => {
  switch (action.type) {
    case asyncActionTypes.INFO_FOR_PURCHASE_METRIC.SUCCESS:
      return {
        ...state,
        ancillaries: action.ancillaries,
      };
    case asyncActionTypes.INFO_FOR_PURCHASE_METRIC.START:
    case asyncActionTypes.INFO_FOR_PURCHASE_METRIC.FAIL:
    default:
      return {
        ...state,
      };
  }
};

export default infoForPurchaseMetric;
